import classNames from 'classnames/bind';
import { ReactNode } from 'react';

import { getPushDeviceToken } from '@flight-workspace/common-client/src/util/naverapp';
import { useCreatePriceChangesSubscription } from 'hooks/usePriceChangesSubscriptions';
import { PriceChangesSubscription } from 'types/apollo';
import styles from '../index.module.scss';

const cx = classNames.bind(styles);

interface Props {
  changes: number[];
  children: ReactNode;
  clickCode: string;
  isDisabled: boolean;
  subscription: PriceChangesSubscription;
  onCompleted(): void;
}

export default function CreateButton({
  changes,
  children,
  clickCode,
  isDisabled,
  subscription,
  onCompleted,
}: Props) {
  const {
    adultCount,
    childCount,
    infantCount,
    cabinClass,
    isNonstop,
    itineraries,
    tripType,
    originalMinPrice,
  } = subscription;
  const createPriceChangesSubscription = useCreatePriceChangesSubscription();

  function onError() {
    window.alert(
      '일시적인 오류로 가격 변동 알림을 설정할 수 없습니다.\n잠시 후 다시 시도해 주시기 바랍니다.',
    );
  }

  async function onCreate() {
    const deviceToken = await getPushDeviceToken();

    createPriceChangesSubscription({
      variables: {
        subscription: {
          adultCount,
          childCount,
          infantCount,
          cabinClass,
          isNonstop,
          itineraries: itineraries.map(
            ({
              departureLocationCode,
              arrivalLocationCode,
              departureDate,
            }) => ({
              departureLocationCode,
              arrivalLocationCode,
              departureDate,
            }),
          ),
          tripType,
          changes,
          minPrice: originalMinPrice,
        },
        deviceToken,
      },
      onCompleted,
      onError,
    });
  }

  return (
    <button
      type="button"
      className={cx('apply')}
      disabled={isDisabled}
      onClick={onCreate}
      data-event-nlog="click"
      data-event-area-code={clickCode}
    >
      {children}
    </button>
  );
}
